export var AvatarColor;
(function (AvatarColor) {
    AvatarColor[AvatarColor["COLOR1"] = 0] = "COLOR1";
    AvatarColor[AvatarColor["COLOR2"] = 1] = "COLOR2";
    AvatarColor[AvatarColor["COLOR3"] = 2] = "COLOR3";
    AvatarColor[AvatarColor["COLOR4"] = 3] = "COLOR4";
    AvatarColor[AvatarColor["COLOR5"] = 4] = "COLOR5";
    AvatarColor[AvatarColor["COLOR6"] = 5] = "COLOR6";
})(AvatarColor || (AvatarColor = {}));
const NUMBER_OF_COLORS = Object.keys(AvatarColor).length / 2;
let nextColor = AvatarColor.COLOR1;
const assignedColorMap = {};
const getNextColor = () => {
    nextColor = (nextColor + 1) % NUMBER_OF_COLORS;
    return nextColor;
};
export const getAvatarColor = (participantId) => {
    if (assignedColorMap[participantId]) {
        return assignedColorMap[participantId];
    }
    const color = getNextColor();
    assignedColorMap[participantId] = color;
    return color;
};
//# sourceMappingURL=avatar-color.js.map